<template>
  <div class="number-input">

    <div class="subsection first">
      <label v-if="!!label">{{ label + ( isMandatory ? ' *' : '') }}</label>
      <input
        type="text"
        :placeholder="placeholder"
        v-model="value1"
        v-on:keypress="isNumber($event)"
        v-on:change="onInput"
        :class="[ isError ? 'error' : '']"
      />
      <span v-if="isError" id="error-message" class="error inline">
        {{ errorMsg }}
      </span>
    </div>
  </div>
</template>

<script>

export default {
  name: 'NumberInput',
  props: {
    label: {
      required: true,
    },
    isMandatory: {
      default: false,
    },
    placeholder: {
      default: '$...',
    },
  },
  computed: {
    isError() {
      return this.errorMsg !== '';
    },
    valuesObject() {
      return {
        value1: this.value1,
        error: this.isError,
        label: this.label,
      };
    },
  },
  created() {
    this.$parent.$on('validate-fields', this.validate);
    this.$parent.$on(`${this.label}-set-value`, this.setValue);
  },
  data() {
    return {
      errorMsg: '',
      value1: '',
    };
  },
  methods: {
    isNumber(evt) {
      const event = evt || window.event;
      const charCode = (event.which) ? event.which : event.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        event.preventDefault();
        return false;
      }
      return true;
    },
    validate() {
      this.errorMsg = '';

      if (this.isMissingInput()) {
        this.errorMsg = 'Please enter a value.';
      }

      this.$emit('validated-fields', this.valuesObject);
    },
    isMissingInput() {
      return this.isMandatory && this.value1 === '';
    },
    setValue(value) {
      this.value1 = value;
    },
    onInput() {
      this.$emit('input', this.valuesObject);
    },
  },
};
</script>

<style lang="scss" scoped>

label {
  @apply ut-font-bold ut-text-sm ut-pb-3 ut-tracking-normal;
  line-height: 24px;
}

.first {
  display: inline-block;
  @apply ut-w-full;
  @screen md {
    width: 58%;
  }
  margin-right: 10px;
}

.second {
  display: inline-block;
  @apply ut-w-full;
  @screen md {
    width: 40%;
  }
}

.half {
  display: inline-block;
  width: 50%;
}

.half.first {
  width: 48%;
  margin-right: 5px;
}

</style>
